import { gql } from 'apollo-boost'

const miniMe = gql`
  query me {
    me {
      id
      nome
      ruolo
      mostraStatisticheAgenti
    }
  }
`

export default miniMe


// WEBPACK FOOTER //
// ./src/graphql/queries/miniMe.js